import { Event_ } from '../Event_';
export class CompositionEvent_ extends Event_ {
    get data() {
        return this.reactEvent.data;
    }
}
